<template>
    <div class="locale-switcher">
        <!-- {{ initLocale() }} -->
        <!--<v-select-->
            <!--:items="locales"-->
        <!--&gt;</v-select>-->

        <!--<b-nav-item-dropdown :dropup="dropup" :text="dropdownLbl" right>-->
            <span
            class="locale-link"
            v-for="locale in locales"
            :key="locale.id"
            @click="setLocale(locale)"
            :class="{ 'is-current': locale === activeLocale }"
            href="#">
                {{ getLanguageString(locale) }}
            </span>
        <!--</b-nav-item-dropdown>-->

        <v-snackbar
        :color="snackBarType"
        :multi-line="mode === 'multi-line'"
        :vertical="mode === 'vertical'"
        v-model="snackBar"
        >
            <span style="font-size: 120%;">{{ snackBarMessage }}</span>
            <v-btn dark flat @click.native="snackBar = false">{{ $t('site.common.close') }}</v-btn>
        </v-snackbar>
    </div>
</template>

<script>

    import Vue from 'vue'
    // Restore locale from cookie, if it was set
    import VueCookie from 'vue-cookie'
    import { loadLanguageAsync } from '../main'
    Vue.use(VueCookie)

    const localeStrings = {
        blank: "BLANK",
        en: "English",
        nl: "Nederlands",
        ru: "Russian",
        ua: "Ukrainian",
        fr: "Français",
        de: "Deutsch"
    }

    Vue.config.lang = VueCookie.get('locale') || 'en'
    console.log("Locale from cookie = " + Vue.config.lang + ": language = " + localeStrings[Vue.config.lang])

    export default {
        props: {
            locales: {
                type: Array,
                default: ['en']
            },
            showFull: Boolean,
            dropup: Boolean,
            locLabel: {
                type: String,
                default: ''
            }
        },
        created() {
            this.setLocale( VueCookie.get('locale') || 'en');
        },
        data: function () {
            return {
                activeLocale: Vue.config.lang,
                snackBarMessage: "",
                snackBarType: "success",
                snackBar: false,
                mode: "multi-line",
            }
        },
        computed: {
            dropdownLbl: function () {
                return this.locLabel ? this.locLabel : this.activeLocale
            }
        },
        methods: {
            setLocale: function (locale) {
                Vue.config.lang = locale;
                this.activeLocale = locale;

                if( locale !== 'en' && locale !== 'blank') {
                    loadLanguageAsync(locale).then( (success) => {
                        this.snackBarMessage = "Loaded Locale: " + locale + " successfully";
                        this.snackBarType = "success"
                        this.snackBar = true;
                    }).catch( (err) => {
                        this.snackBarMessage = err.message || err;
                        this.snackBarType = "error";
                        this.snackBar = true;
                    })
                }
                else {
                    try {
                       // Vue.config.lang = locale;
                        this.$cookie.set('locale', locale)
                        this.$i18n.locale = Vue.config.lang;
                        console.log("New locale = " + Vue.config.lang + ": language = " + localeStrings[Vue.config.lang])
                    }catch(err) {
                        console.error(err || "undefined error..");
                    }

                }
                console.log("Active local is: " + this.activeLocale);
            },
            getLanguageString: function (locale) {
                return this.showFull ? localeStrings[locale] : locale
            }
        }
    }
</script>

<style scoped>
    .is-current {
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/components/LocaleSwitcher.vue